import React from 'react';
import {Card, Col, Container, Row, Tab, Table, Tabs} from 'react-bootstrap';
import '../layout/main.scss';
import './judgespace.scss';


function JudgeSpace() {
    // @ts-ignore
    return (
        <div className="App">
            <div className="judgespace">
                <Container>
                    <div className="mn-blocks">
                        <h4>Judge space</h4>
                        <div className="judgestats">
                            <Row>
                                <Col className="col-xs-12 col-sm-6 col-md-4">
                                    <div className="cards">
                                        <h5>Total pool space</h5>
                                        <h4>10 000 KIW</h4>
                                        <p>890 / 10000 owned (8.9%)</p>
                                    </div>
                                </Col>
                                <Col className="col-xs-12 col-sm-6 col-md-4">
                                    <div className="cards">
                                        <h5>Judge pool space available</h5>
                                        <h4>890 KIW</h4>
                                        <p>10 KIW already staked</p>
                                    </div>
                                </Col>
                                <Col className="col-xs-12 col-sm-6 col-md-4">
                                    <div className="cards">
                                        <h5>Pool space not matched</h5>
                                        <h4>100 KIW</h4>
                                        <p>900 / 10000 KIW matched</p>
                                    </div>
                                </Col>
                            </Row>
                        </div>
                    </div>
                    <div className="mn-blocks home-spotlight">
                        <h4>Cases</h4>
                        <div className="collection-content">
                            <Tabs defaultActiveKey="Pending" id="pending-tab" className="mb-3">
                                <Tab eventKey="Pending" title="Pending Cases">
                                    <div className="mn-blocks home-asset casestable">
                                        <Row xs={1} sm={2} md={3} lg={4} className="g-4">
                                            <Table hover>
                                                <thead>
                                                <tr>
                                                    <th>Cert ID</th>
                                                    <th>Status</th>
                                                    <th>NFT name</th>
                                                    <th>Chain</th>
                                                    <th>Contract</th>
                                                    <th>Token ID</th>
                                                    <th>KIW staked</th>
                                                    <th></th>
                                                    <th>Judge</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr>
                                                    <td>001</td>
                                                    <td>PENDING</td>
                                                    <td>The precious box</td>
                                                    <td>Ethereum</td>
                                                    <td>0xe4u21...d491</td>
                                                    <td>001</td>
                                                    <td>20</td>
                                                    <td>View</td>
                                                    <td>Shabi</td>
                                                </tr>
                                                <tr>
                                                    <td>002</td>
                                                    <td>PENDING</td>
                                                    <td>The Wizard of Oz</td>
                                                    <td>Bitcoin</td>
                                                    <td>0xe4u21...d491</td>
                                                    <td>002</td>
                                                    <td>20</td>
                                                    <td>View</td>
                                                    <td>Antonino</td>
                                                </tr>
                                                <tr>
                                                    <td>003</td>
                                                    <td>PENDING</td>
                                                    <td>Back to the Future</td>
                                                    <td>Bitcoin</td>
                                                    <td>0xe4u21...d491</td>
                                                    <td>003</td>
                                                    <td>20</td>
                                                    <td>View</td>
                                                    <td>Kéta</td>
                                                </tr>
                                                <tr>
                                                    <td>004</td>
                                                    <td>PENDING</td>
                                                    <td>Metaverse reality check</td>
                                                    <td>Ethereum</td>
                                                    <td>0xe4u21...d491</td>
                                                    <td>004</td>
                                                    <td>20</td>
                                                    <td>View</td>
                                                    <td>Yeye</td>
                                                </tr>
                                                <tr>
                                                    <td>005</td>
                                                    <td>PENDING</td>
                                                    <td>Rock the Meta!</td>
                                                    <td>Ethereum</td>
                                                    <td>0xe4u21...d491</td>
                                                    <td>005</td>
                                                    <td>20</td>
                                                    <td>View</td>
                                                    <td>Pierre</td>
                                                </tr>
                                                <tr>
                                                    <td>006</td>
                                                    <td>PENDING</td>
                                                    <td>Sherlock Holmes</td>
                                                    <td>Ethereum</td>
                                                    <td>0xe4u21...d491</td>
                                                    <td>006</td>
                                                    <td>20</td>
                                                    <td>View</td>
                                                    <td>Lulu</td>
                                                </tr>
                                                <tr>
                                                    <td>007</td>
                                                    <td>PENDING</td>
                                                    <td>The Neverending Story</td>
                                                    <td>Ethereum</td>
                                                    <td>0xe4u21...d491</td>
                                                    <td>007</td>
                                                    <td>20</td>
                                                    <td>View</td>
                                                    <td>Mila</td>
                                                </tr>
                                                <tr>
                                                    <td>008</td>
                                                    <td>PENDING</td>
                                                    <td>Space Jam</td>
                                                    <td>Ethereum</td>
                                                    <td>0xe4u21...d491</td>
                                                    <td>008</td>
                                                    <td>20</td>
                                                    <td>View</td>
                                                    <td>Adeline</td>
                                                </tr>
                                                <tr>
                                                    <td>009</td>
                                                    <td>PENDING</td>
                                                    <td>Finding Meta</td>
                                                    <td>Ethereum</td>
                                                    <td>0xe4u21...d491</td>
                                                    <td>009</td>
                                                    <td>20</td>
                                                    <td>View</td>
                                                    <td>Audrey</td>
                                                </tr>
                                                <tr>
                                                    <td>010</td>
                                                    <td>PENDING</td>
                                                    <td>When does it start?</td>
                                                    <td>Ethereum</td>
                                                    <td>0xe4u21...d491</td>
                                                    <td>010</td>
                                                    <td>20</td>
                                                    <td>View</td>
                                                    <td>Julien</td>
                                                </tr>
                                                <tr>
                                                    <td>011</td>
                                                    <td>PENDING</td>
                                                    <td>Activate!</td>
                                                    <td>Ethereum</td>
                                                    <td>0xe4u21...d491</td>
                                                    <td>011</td>
                                                    <td>20</td>
                                                    <td>View</td>
                                                    <td>Sarah</td>
                                                </tr>
                                                </tbody>
                                            </Table>
                                        </Row>
                                    </div>
                                </Tab>
                                <Tab eventKey="ClosedCases" title="ClosedCases">
                                    <div className="mn-blocks home-asset casestable">
                                        <Row xs={1} sm={2} md={3} lg={4} className="g-4">
                                            <Table hover>
                                                <thead>
                                                <tr>
                                                    <th>Cert ID</th>
                                                    <th>Status</th>
                                                    <th>NFT name</th>
                                                    <th>Chain</th>
                                                    <th>Contract</th>
                                                    <th>Token ID</th>
                                                    <th>KIW staked</th>
                                                    <th></th>
                                                    <th>Judge</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr>
                                                    <td>001</td>
                                                    <td>CLOSED</td>
                                                    <td>The precious box</td>
                                                    <td>Ethereum</td>
                                                    <td>0xe4u21...d491</td>
                                                    <td>001</td>
                                                    <td>20</td>
                                                    <td>View</td>
                                                    <td>Shabi</td>
                                                </tr>
                                                <tr>
                                                    <td>002</td>
                                                    <td>CLOSED</td>
                                                    <td>The Wizard of Oz</td>
                                                    <td>Bitcoin</td>
                                                    <td>0xe4u21...d491</td>
                                                    <td>002</td>
                                                    <td>20</td>
                                                    <td>View</td>
                                                    <td>Antonino</td>
                                                </tr>
                                                <tr>
                                                    <td>003</td>
                                                    <td>CLOSED</td>
                                                    <td>Back to the Future</td>
                                                    <td>Bitcoin</td>
                                                    <td>0xe4u21...d491</td>
                                                    <td>003</td>
                                                    <td>20</td>
                                                    <td>View</td>
                                                    <td>Kéta</td>
                                                </tr>
                                                <tr>
                                                    <td>004</td>
                                                    <td>CLOSED</td>
                                                    <td>Metaverse reality check</td>
                                                    <td>Ethereum</td>
                                                    <td>0xe4u21...d491</td>
                                                    <td>004</td>
                                                    <td>20</td>
                                                    <td>View</td>
                                                    <td>Yeye</td>
                                                </tr>
                                                <tr>
                                                    <td>005</td>
                                                    <td>CLOSED</td>
                                                    <td>Rock the Meta!</td>
                                                    <td>Ethereum</td>
                                                    <td>0xe4u21...d491</td>
                                                    <td>005</td>
                                                    <td>20</td>
                                                    <td>View</td>
                                                    <td>Pierre</td>
                                                </tr>
                                                </tbody>
                                            </Table>
                                        </Row>
                                    </div>
                                </Tab>
                                <Tab eventKey="Electorlist" title="Electorlist">
                                    <div className="mn-blocks home-asset casestable">
                                        <Row xs={1} sm={2} md={3} lg={4} className="g-4">
                                            <Table hover>
                                                <thead>
                                                <tr>
                                                    <th>Cert ID</th>
                                                    <th>Status</th>
                                                    <th>NFT name</th>
                                                    <th>Chain</th>
                                                    <th>Contract</th>
                                                    <th>Token ID</th>
                                                    <th>KIW staked</th>
                                                    <th></th>
                                                    <th>Judge</th>
                                                </tr>
                                                </thead>
                                                <tbody>
                                                <tr>
                                                    <td>006</td>
                                                    <td>VALID</td>
                                                    <td>Sherlock Holmes</td>
                                                    <td>Ethereum</td>
                                                    <td>0xe4u21...d491</td>
                                                    <td>006</td>
                                                    <td>20</td>
                                                    <td>View</td>
                                                    <td>Lulu</td>
                                                </tr>
                                                <tr>
                                                    <td>007</td>
                                                    <td>VALID</td>
                                                    <td>The Neverending Story</td>
                                                    <td>Ethereum</td>
                                                    <td>0xe4u21...d491</td>
                                                    <td>007</td>
                                                    <td>20</td>
                                                    <td>View</td>
                                                    <td>Mila</td>
                                                </tr>
                                                <tr>
                                                    <td>008</td>
                                                    <td>VALID</td>
                                                    <td>Space Jam</td>
                                                    <td>Ethereum</td>
                                                    <td>0xe4u21...d491</td>
                                                    <td>008</td>
                                                    <td>20</td>
                                                    <td>View</td>
                                                    <td>Adeline</td>
                                                </tr>
                                                <tr>
                                                    <td>009</td>
                                                    <td>VALID</td>
                                                    <td>Finding Nemo in Meta</td>
                                                    <td>Ethereum</td>
                                                    <td>0xe4u21...d491</td>
                                                    <td>009</td>
                                                    <td>20</td>
                                                    <td>View</td>
                                                    <td>Audrey</td>
                                                </tr>
                                                <tr>
                                                    <td>010</td>
                                                    <td>VALID</td>
                                                    <td>When does it start?</td>
                                                    <td>Ethereum</td>
                                                    <td>0xe4u21...d491</td>
                                                    <td>010</td>
                                                    <td>20</td>
                                                    <td>View</td>
                                                    <td>Julien</td>
                                                </tr>
                                                <tr>
                                                    <td>011</td>
                                                    <td>VALID</td>
                                                    <td>Activate!</td>
                                                    <td>Ethereum</td>
                                                    <td>0xe4u21...d491</td>
                                                    <td>011</td>
                                                    <td>20</td>
                                                    <td>View</td>
                                                    <td>Sarah</td>
                                                </tr>
                                                </tbody>
                                            </Table>
                                        </Row>
                                    </div>
                                </Tab>
                            </Tabs>
                        </div>
                    </div>
                </Container>
            </div>
        </div>
    );
}

export default JudgeSpace;
